import { cn } from "@/lib/utils";
import type { CommercialStatus } from "@/lib/types";
import { CheckCircle2, Clock, XCircle, Ban, FileText } from "lucide-react";

const config: Record<CommercialStatus, { label: string; className: string; Icon: typeof Clock }> = {
  PENDENTE_VALIDACAO: {
    label: "Em análise",
    className: "bg-warning/10 text-warning border-warning/30",
    Icon: Clock,
  },
  VALIDADO: {
    label: "Validado",
    className: "bg-success/10 text-success border-success/30",
    Icon: CheckCircle2,
  },
  REJEITADO: {
    label: "Rejeitado",
    className: "bg-destructive/10 text-destructive border-destructive/30",
    Icon: XCircle,
  },
  BLOQUEADO: {
    label: "Bloqueado",
    className: "bg-muted text-muted-foreground border-border",
    Icon: Ban,
  },
};

export function StatusBadge({
  status,
  incomplete,
  className,
}: {
  status: CommercialStatus;
  /** Cadastro iniciado mas sem ficha comercial — diferencia do "Em análise". */
  incomplete?: boolean;
  className?: string;
}) {
  if (incomplete && status === "PENDENTE_VALIDACAO") {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium bg-muted text-muted-foreground border-border",
          className,
        )}
      >
        <FileText className="h-3.5 w-3.5" />
        Cadastro incompleto
      </span>
    );
  }
  const { label, className: c, Icon } = config[status];
  return (
    <span className={cn("inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium", c, className)}>
      <Icon className="h-3.5 w-3.5" />
      {label}
    </span>
  );
}
